import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex, themeColor } from '@elparking/components'
import styled from 'styled-components'

export const FilterButton = styled(Button.bordered)`
    padding: 8px;
    height: auto;
    border: 1px solid ${themeColor('gray20')};
    border-radius: 4px;
    color: ${({selected}) => selected ? themeColor('white') : themeColor('gray')};
    background: ${({selected}) => selected ? themeColor('main') : themeColor('white')};

    &:hover {
        background: ${({selected}) => selected ? themeColor('darkMain') : themeColor('lightGray20')};
        color: ${({selected}) => selected ? themeColor('white') : themeColor('gray')};
    }
`
function ParkingService ({children, value, selected, width, onClick}) {
    return (
        <Flex w={width} mb='10px'>
            <FilterButton width='100%' selected={selected} onClick={() => { onClick(value, !selected) }}>
                {children}
            </FilterButton>
        </Flex>
    )
}

ParkingService.propTypes = {
    children: PropTypes.element,
    value: PropTypes.string,
    selected: PropTypes.bool,
    width: PropTypes.string,
    onClick: PropTypes.func,
}

ParkingService.defaultProps = {
    selected: false,
}

export default ParkingService
